export default {
  isQianniu: (/(AEF|Qianniu)\/[\d\.]+/i).test(navigator.userAgent),
};



// WEBPACK FOOTER //
// ./src/common/qianniu-pc-app-detect.js